import React, { useContext, useEffect, useRef, useState } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import UserContext from "../../../utils/Contexts/UserContext";
import axiosInstance from "../../../utils/Requests/axios";
import ConfirmOrderDetail from "./ConfirmOrderDetails";
import Footer from "../../Footer";

function OrderConfirmation() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);
  const { userData } = useContext(UserContext);
  const [orderData, setOrderData] = useState(null);
  const [guestTotal, setGuestTotal] = useState(null);
  const [linkTotal, setLinkTotal] = useState(null);
  const [nicheTotal, setNicheTotal] = useState(null);
  const [guestPosts, setGuestPosts] = useState([]);
  const [linkInserts, setLinkInserts] = useState([]);
  const [nicheEdits, setNicheEdits] = useState([]);
  const [transactions, setTransactions] = useState([]);

  if (!orderId) {
    navigate("/cart");
  }

  const getConfirmedOrderData = () => {
    const url = `/users/${userData?.uuid}/orders/${orderId}`;
    axiosInstance
      .get(url)
      .then((response) => {
        setOrderData(response?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const orderDataFetched = useRef(false);
  useEffect(() => {
    if (orderDataFetched.current) return;
    orderDataFetched.current = true;
    getConfirmedOrderData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (orderData?.items) {
      const guestPostsItems = orderData?.items.filter(
        (item) => item.type === 1
      );
      const linkInsertItems = orderData?.items.filter(
        (item) => item.type === 2
      );
      const nicheEditItems = orderData?.items.filter((item) => item.type === 3);
      const transactionsData = orderData?.transactions;

      setGuestPosts(guestPostsItems);
      setLinkInserts(linkInsertItems);
      setNicheEdits(nicheEditItems);
      setTransactions(transactionsData);

      const guestTotal = orderData?.items
        .filter((item) => item.type === 1) // Filter items with type 1
        .reduce((sum, item) => sum + (item?.post?.offer?.price || 0), 0);
      setGuestTotal(guestTotal);
      const linksTotal = orderData?.items
        .filter((item) => item.type === 2) // Filter items with type 2
        .reduce((sum, item) => sum + (item?.insert?.offer?.price || 0), 0);
      setLinkTotal(linksTotal);
      const nicheTotal = orderData?.items
        .filter((item) => item.type === 3) // Filter items with type 2
        .reduce((sum, item) => sum + (item?.edit?.offer?.price || 0), 0);
      setNicheTotal(nicheTotal);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData]);

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1100);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1100);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <main id="content" role="main" className="main">
      <div className="content container-fluid">
        <div
          className="page-header"
          style={{
            position: "relative",
            paddingBottom: "unset",
            borderBottom: "unset",
          }}
        >
          <div
            style={{
              position: "absolute",
              bottom: "-12px",
              right: "0",
              left: "-25px",
              width: "100vw",
              height: "2px",
              backgroundColor: "var(--separator-bg)",
            }}
          ></div>
          <div className="row align-items-center mb-3">
            <div className="col-md d-md-flex justify-content-between flex-wrap align-items-center mb-sm-2 mb-2 mb-md-0">
              <div className="mb-sm-6 mb-lg-0 mb-md-4 mb-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb breadcrumb-no-gutter">
                    {!isSmallScreen && (
                      <li className="breadcrumb-item">
                        {/* eslint-disable-next-line */}
                        <a
                          className="breadcrumb-link cursor-pointer"
                          style={{
                            color: "rgba(145, 146, 147, 1)",
                            opacity: "50%",
                          }}
                          onClick={() => navigate("/cart")}
                        >
                          {t("Cart")}
                        </a>
                      </li>
                    )}
                    <li
                      className="breadcrumb-item"
                      style={{ color: "rgba(145, 146, 147, 1)" }}
                      aria-current="page"
                    >
                      {t("Order Confirmation")}
                    </li>
                  </ol>
                </nav>
                <h1 className="page-header-title">
                  {t("Order")} #{orderData?.code}
                </h1>
              </div>
              <div className="d-flex gap-3">
                <div className="d-flex align-items-center gap-2 flex-column flex-sm-column flex-md-row">
                  <div
                    className={` rounded-circle d-flex justify-content-center align-items-center ${
                      selectedTheme === "dark"
                        ? "bg-step text-dark"
                        : "bg-secondary text-white"
                    }`}
                    style={{
                      height: "35px",
                      width: "35px",
                      fontSize: "12px",
                      fontWeight: "700",
                    }}
                  >
                    1
                  </div>
                  <span className="text-center text-dark step-font">
                    {t("Order Details")}
                  </span>
                </div>
                <div
                  className="border-query"
                  style={{
                    height: "2px",
                    width: "100px",
                    alignSelf: "center",
                    backgroundColor: "var(--separator-bg)",
                  }}
                ></div>
                <div className="d-flex align-items-center gap-2 flex-column flex-sm-column flex-md-row">
                  <div
                    className={`rounded-circle d-flex justify-content-center align-items-center ${
                      selectedTheme === "dark"
                        ? "bg-step text-dark"
                        : "bg-secondary text-white"
                    }`}
                    style={{
                      height: "35px",
                      width: "35px",
                      fontSize: "12px",
                      fontWeight: "700",
                    }}
                  >
                    2
                  </div>
                  <span className="text-center text-dark step-font">
                    {t("Payment Method")}
                  </span>
                </div>
                <div
                  className="border-query"
                  style={{
                    height: "2px",
                    width: "100px",
                    alignSelf: "center",
                    backgroundColor: "var(--separator-bg)",
                  }}
                ></div>
                <div className="d-flex align-items-center gap-2 flex-column flex-sm-column flex-md-row">
                  <div
                    className="rounded-circle d-flex justify-content-center align-items-center bg-primary text-white"
                    style={{
                      height: "35px",
                      width: "35px",
                      fontSize: "12px",
                      fontWeight: "700",
                    }}
                  >
                    3
                  </div>
                  <span className="text-center text-dark step-font">
                    {t("Order Confirmation")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ConfirmOrderDetail
          orderData={orderData}
          guestTotal={guestTotal}
          linkTotal={linkTotal}
          nicheTotal={nicheTotal}
          guestPosts={guestPosts}
          linkInserts={linkInserts}
          nicheEdits={nicheEdits}
          transactions={transactions}
        />
      </div>
      <Footer />
    </main>
  );
}

export default OrderConfirmation;
